<template>
  <div>

    <el-row :data="titleData">
      <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li><span>供应商</span>：{{ titleData[0].SUPPLIER_NAME }}</li>
          <li><span>项目点</span>：{{ titleData[0].PROJECT_NAME }}</li>
          <li><span>项目点地址</span>：{{ titleData[0].ADDRESS }}</li>
          <li><span>送货日期</span>：{{ titleData[0].SEND_DAY }}</li>
          <li><span>订购总金额</span>：{{ titleData[0].TOTAL_SUPPLIER_FEE }}</li>
          <li><span>订单备注</span>：{{ titleData[0].ORDER_COMMENT }}</li>
        </ul>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="{ span: 12, offset: 0 }" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li><span>制单人</span>：{{ managername }}</li>
          <li><span>档口</span>：{{ titleData[0].DK_NAME }}</li>
          <li><span>项目点电话</span>：{{ titleData[0].TELPHONE }}</li>
          <li><span>订单编号</span>：{{ titleData[0].ORDER_CODE }}</li>
          <li><span>实收总金额</span>：{{ titleData[0].REAL_TOTAL_SUPPLIER_FEE }}</li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" border stripe style="width: 100%">
          <el-table-column type="index" label="序号" width="50" min-width="30"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编号" min-width="150"></el-table-column>
          <el-table-column label="名称" prop="SHORT_NAME" min-width="100"></el-table-column>
          <el-table-column label="品牌" prop="BRAND" min-width="100"></el-table-column>
          <el-table-column label="规格" prop="SPECIFICATION" min-width="100"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="REAL_PRICE" label="单价（元）"></el-table-column>
          <el-table-column prop="BEFORE_TAX_PRICE" label="不含税单价（元）"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="订购数量"></el-table-column>
          <el-table-column prop="NEED_COUNT" label="送货数量"></el-table-column>
          <el-table-column prop="REAL_COUNT" label="实收数量"></el-table-column>
          <el-table-column prop="RETURN_COUNT" label="退货数量"></el-table-column>
          <el-table-column prop="REASON" label="退货原因"></el-table-column>
          <el-table-column prop="TOTAL_FEE" label="总价（元）"></el-table-column>
          <el-table-column prop="CATALOG_NAME" label="分类"></el-table-column>
          <el-table-column prop="PRODUCT_COMMENT" label="备注"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row :data="titleData">
      <el-col>
        <p>收货时间：</p>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">
        <p>送货员：</p>
      </el-col>
      <el-col :span="6">
        <p>项目经理：</p>
      </el-col>
      <el-col :span="6">
        <p>厨师长：</p>
      </el-col>
      <el-col :span="6">
        <p>验收人员：</p>
      </el-col>
    </el-row>
    <el-row style="margin-top: 10px;">
      <el-col>
        <el-steps :active="this.statusFlag" finish-status="success" v-show="this.statusFlag !== 0" :space="200">
          <el-step :title="item.T" :description="item.D" v-for="item in checkData" :key="item.value"></el-step>
        </el-steps>
        <h4 v-show="this.statusFlag === 0" style="color:#E6A23C">暂无流程记录信息</h4>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { orderConfirmDetailFun } from 'api/sellOrder';

export default {
  data() {
    return {
      tableData: [],
      titleData: [
        {
          SUPPLIER_NAME: '',
          PROJECT_ADDRESS: '',
          ORDER_CODE: '',
          PROJECT_NAME: '',
          SEND_DAY: '',
          PROJECT_TELPHONE: '',
          DK_NAME: '',
        },
      ],
      checkData: [],
      statusFlag: 0,
      managername: sessionStorage.getItem('name'),

    };
  },
  created() {
    this.queryOrderDetailListData();
  },
  methods: {
    queryOrderDetailListData() {
      const params = {
        ORDER_ID: sessionStorage.getItem('SEARCH_ORDER_ID'),
      };
      orderConfirmDetailFun(params).then((result) => {
        if (result[0].length !== 0) {
          this.tableData = result.length > 0 ? result[0].DETAIL.map((item) => ({ ...item, BEFORE_TAX_PRICE: Number(item.BEFORE_TAX_PRICE).toFixed(2) })) : [];
          this.titleData = result.length > 0 ? result[0].TITLE : [];
          this.checkData = result.length > 0 ? result[0].OR[0].DATA : [];
          this.statusFlag = result.length > 0 ? result[0].OR[0].RN : 0;
          // this.printStatus = result[0].PRINT_FLAG;
        } else {
          this.tableData = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>

<style scoped>
ul {
  list-style: none;
  min-height: 100px;
  padding: 0
}

li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 14px;
}

p {
  font-size: 14px;
}

li span {
  display: inline-block;
  width: 70px;
  text-align-last: justify;
}
</style>



// WEBPACK FOOTER //
// src/components/sellOrderManage/searchSellOrderDetail.vue